import React, { useRef, useState } from "react";
import { Play } from "lucide-react";

export const ClickToPlayVideo = ({ src, poster, label = "Play video", className = "" }) => {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const handlePlay = () => {
    setStarted(true);
    const v = videoRef.current;
    if (v) {
      v.play();
    }
  };

  return (
    <div
      className={`relative overflow-hidden bg-black border border-zinc-800 ${className}`}
      data-testid="tyler-video-wrapper"
    >
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        controls={started}
        playsInline
        preload="metadata"
        className="w-full h-full object-cover"
        data-testid="tyler-video-player"
      />
      {!started && (
        <button
          type="button"
          onClick={handlePlay}
          aria-label={label}
          data-testid="tyler-video-play-button"
          className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-black/40 hover:bg-black/25 transition-colors group"
        >
          <span className="flex items-center justify-center w-16 h-16 rounded-full bg-[#C69453] text-black shadow-lg group-hover:scale-105 transition-transform">
            <Play className="w-7 h-7 fill-current translate-x-0.5" />
          </span>
          <span className="text-white text-xs uppercase tracking-widest font-semibold">
            {label}
          </span>
        </button>
      )}
    </div>
  );
};

export default ClickToPlayVideo;
